import { SearchableDropdown } from "components/designV2/searchableDropdown/searchableDropdown";
import { SearchableDropdownOption } from "components/designV2/searchableDropdown/searchableDropdown.types";
import { AxiosError } from "axios";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Api } from "services/api/api.service";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";
import { CompanyWorker } from "model/Company";
import { WidthWrapper } from "./workerDropDown.styled";

type Props = {
  setSelectedWorker: React.Dispatch<
    React.SetStateAction<CompanyWorker | undefined>
  >;
  selectedWorker: CompanyWorker | undefined;
  onlyActiveWorkers: boolean;
  width?: number;
  disabled?: boolean;
  lazyLoad?: boolean;
};

export const WorkerDropdown: React.FC<Props> = (props) => {
  const [workers, setWorkers] = useState<CompanyWorker[]>([]);
  const [hasRequestedWorkers, setHasRequestedWorkers] = useState(false);
  const [{ company }] = useCompanyStore();
  const { t } = useTranslation();
  const shouldLoadWorkers = !props.lazyLoad || hasRequestedWorkers;

  useEffect(() => {
    if (!company?.id || !shouldLoadWorkers) return;
    Api()
      .company.worker.getCompanyWorkersV2List(
        company.id,
        props.onlyActiveWorkers,
      )
      .then((res) => setWorkers(res.data))
      .catch((e: AxiosError) => {
        console.error("Error when getting workers", e);
      });
  }, [company?.id, props.onlyActiveWorkers, shouldLoadWorkers]);

  const options = useMemo<SearchableDropdownOption[]>(
    () =>
      workers.map((w) => ({
        value: w.id.toString(),
        label: `${w.firstName} ${w.lastName}`,
        rightText: `[ID: ${w.id}]`,
      })),
    [workers],
  );

  const handleChange = (value: string): void => {
    const worker = workers.find((w) => w.id.toString() === value);
    props.setSelectedWorker(worker);
  };

  const dropdown = (
    <SearchableDropdown
      options={options}
      value={props.selectedWorker?.id.toString()}
      placeholder={t("Salary.SearchForWorker")}
      disabled={props.disabled}
      fullWidth={props.width !== undefined}
      onChange={handleChange}
      onClear={() => props.setSelectedWorker(undefined)}
      onFocus={() => {
        if (!props.lazyLoad) return;
        setHasRequestedWorkers(true);
      }}
    />
  );

  if (props.width !== undefined) {
    return <WidthWrapper $width={props.width}>{dropdown}</WidthWrapper>;
  }

  return dropdown;
};
